import React, { useEffect, useRef, useState } from 'react';
import { cloneDeep, isEmpty, set } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Card, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ImgDropzone from '../../../../../Components/ImgDropzone/ImgDropzone';
import AlignmentConfigComponent from './AlignmentConfig';
import { BoldConfig } from './BoldConfig';
import { BorderConfig } from './BorderConfig';
import { BorderColorConfig } from './BorderColorConfig';
import { BorderStyleConfig } from './BorderStyleConfig';
import { BackgraundColorConfig } from './BackgraundColorConfig';
import { ColorConfig } from './ColorConfig';
import UnderlineColorConfig from './UnderlineColor';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import { useDPPState } from '../../Context/index';
import * as dppAction from '../../Store/DPP.action';
import HeadingSettingComp from '../../../../../Components/DPP/Settings/HeadingSetting';
import URLLinkSettingComp from '../../../../../Components/DPP/Settings/URLLinkSetting';
import DAMSettingComp from '../../../../../Components/DPP/Settings/DAMSetting';
import SourceSettingComp from '../../../../../Components/DPP/Settings/SourceSetting';
import { ProductJourneySetting } from '../../../../../Components/DPP/Settings/ProductJourneySetting';
import { TestingControlSetting } from '../../../../../Components/DPP/Settings/TestingControlSetting';
import { GoogleSetting } from '../../../../../Components/DPP/Settings/GoogleSetting';
import { HtmlSetting } from '../../../../../Components/DPP/Settings/HtmlSetting';
import { ProductImpactSetting } from '../../../../../Components/DPP/Settings/ProductImpactSetting';
import { NavigationSetting } from '../../../../../Components/DPP/Settings/NavigationSetting';
import { SpacerSetting } from '../../../../../Components/DPP/Settings/SpacerSetting';
import { CustomSetting } from '../../../../../Components/DPP/Settings/CustomSetting';
import { customStyles } from '../../../../../Components/helper';
import { CareUserInstructionSetting } from '../../../../../Components/DPP/Settings/CareUserInstructionSetting';
import borderThickSvg from "../../../../../assets/images/Stroke_'Thickness.svg";
import CompanyStampSetting from '../../../../../Components/DPP/Settings/CompanyStampSetting';

function ConfigModal({ toggle, data, dataIndex, submit, customSectionIndex, isFromCustomSection, allCustomSection, customSectionIndexs, libraryBasicData }) {
  const { t } = useTranslation('common');
  const reducer = useSelector((reducerstate) => reducerstate);
  const [obj, setObj] = useState(null);
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    controlKey: '',
    name: '',
    index: null,
  });
  const { dppState } = useDPPState();
  const {
    BomLibraryDetails: { bomOptionsList },
  } = reducer;

  const childRef = useRef();
  const testingRef = useRef();
  const careUserref = useRef();
  const dispatch = useDispatch();
  const alignmentControls = ['heading', 'source'];
  const boldControls = ['heading', 'source'];
  const borderControls = [
    'Text_Area',
    'Text',
    'Signature',
    'Date_Picker',
    'Time_Picker',
    'Number_Decimal',
    'Number_Percentage',
    'HTMLControl',
    'Source',
    'Calculation',
  ];
  const BackgroundControls = ['Text_Area', 'Text', 'Heading', 'Source', 'Calculation', 'Colorfill'];
  const ColorControls = ['heading', 'source'];
  const UnderlineColorControls = ['heading'];
  const verticalStyleOptions = [
    { label: 'Solid', value: 'solid' },
    { label: 'Dashed', value: 'dotted' },
  ];

  const borderStyleOptions = [
    { label: '1px', value: '1px' },
    { label: '3px', value: '3px' },
    { label: '5px', value: '5px' },
  ];

  useEffect(() => {
    if (data?.id === '7' && !data?.otherConfiguration) {
      const updatedData = {
        ...data,
        otherConfiguration: {
          sourceSwitchTitle: true,
        },
      };
      setObj(updatedData);
    } else {
      setObj({ ...data });
    }
  }, [data]);

  const customStylesBorderLine = {
    ...customStyles,
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '32px',
      border: '1px solid #6a6a6a',
    }),
  };
  const customStylesBorderThickness = {
    ...customStyles,
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '22px',
      border: '1px solid #6a6a6a',
    }),
  };

  const onChange = (e, name, i) => {
    const object = cloneDeep(obj);
    switch (name) {
      case 'Label':
        object.label = e;
        break;
      case 'iconHeading':
        object.iconHeading = e === 'iconHeading';
        break;
      case 'isAllBom':
        object.isAllBom = e === 'allBom';
        break;
      case 'thumbnailURL':
        // Accept both boolean (new) and string (legacy) values
        object.thumbnailURL = typeof e === 'boolean' ? e : e === 'thumbnailLink';
        break;

      case 'value':
        object.value = e;
        break;
      case 'subHeaderTitle':
        object.subHeaderTitle = e;
        break;
      case 'productJourneyDescription':
        object.productJourneyDescription = e;
        break;
      case 'tierDescription':
        object.tier[i].tierDescription = e;
        break;
      case 'ethicalAuditStatus':
        object.tier[i].ethicalAuditStatus = e;
        break;
      case 'ethicalAuditDPPStatus':
        object.tier[i].ethicalAuditDPPStatus = e;
        break;
      case 'ethicalAuditDPPDescription':
        object.tier[i].ethicalAuditDPPDescription = e;
        break;
      case 'setDefault':
        object.statusColours.forEach((color, index) => {
          object.statusColours[index] = { ...color, setDefault: false };
        });
        object.statusColours[i].setDefault = e;
        break;
      case 'name':
        object.tier[i].name = e;
        break;
      default:
        object[name] = e;
        break;
    }
    setObj({ ...object });
  };

  const handleURLSwitch = (key) => {
    const object = cloneDeep(obj);
    object[key] = !object[key];
    setObj({ ...object });
  };

  const updateMetaData = (metaData) => {
    const object = cloneDeep(obj);
    if (!isEmpty(metaData)) {
      object.metaData = {
        image: obj?.metaData?.image?.includes('data:image') || obj?.metaData?.image?.includes('url_link') ? obj.metaData?.image : metaData?.image,
        title: metaData?.title,
        description: metaData?.description,
      };
    } else {
      object.metaData = null;
      object.url = '';
      object.showTitle = false;
      object.showDescription = false;
    }
    setObj({ ...object });
  };

  const handleHeadingStyle = (style) => {
    const object = cloneDeep(obj);
    object.headingType = style;
    setObj({ ...object });
  };

  const handleSpacerStyle = (style) => {
    const object = cloneDeep(obj);
    object.spacerHeight = style;
    setObj({ ...object });
  };

  const hasAccessAlignment = (keyName) => {
    return alignmentControls.includes(keyName);
  };
  const hasAccessBold = (keyName) => {
    return boldControls.includes(keyName);
  };
  const hasAccessBorder = (keyName) => {
    return borderControls.includes(keyName);
  };
  const hasAccessBackground = (keyName) => {
    return BackgroundControls.includes(keyName);
  };
  const hasAccessColor = (keyName) => {
    return ColorControls.includes(keyName);
  };
  const hasAccessUnderlineColor = (keyName) => {
    return UnderlineColorControls.includes(keyName);
  };

  const handleOtherConfig = (input, name) => {
    const object = cloneDeep(obj);

    const isSwitch = input.target?.type === 'checkbox';

    const propertyName = name || input.target.name;
    let propertyValue;
    if (name) {
      propertyValue = input.value;
    } else if (isSwitch) {
      propertyValue = input.target.checked; // Switch state
    } else {
      propertyValue = input.target.value;
    }

    const addedObj = { [propertyName]: propertyValue };
    object.otherConfiguration = { ...(object?.otherConfiguration || {}), ...addedObj };
    setObj({ ...object });
  };

  const handleBorderStyle = (val, key) => {
    const objectBorder = cloneDeep(obj);
    const addedObj = { [key]: val?.value };
    objectBorder.otherConfiguration = { ...(objectBorder?.otherConfiguration || {}), ...addedObj };

    setObj({ ...objectBorder });
  };

  const handleFontSize = (val, key) => {
    const object = cloneDeep(obj);
    const addedObj = { [key]: val?.value };
    object.otherConfiguration = { ...(object?.otherConfiguration || {}), ...addedObj };

    setObj({ ...object });
  };

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();
      const { imageRes } = croppedFileUrl;
      const object = { ...obj };
      if (imageModal.controlKey === 'testing_control' && testingRef.current) {
        await testingRef.current.updateTestingLocalState(imageRes, imageModal?.name, imageModal?.index);
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        return;
      }
      if (imageModal.controlKey === 'product_journey_tier') {
        object.tier[imageModal.index].tierIcon = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        return;
      }
      if (imageModal.controlKey === 'product_journey_transport') {
        object.transportIcon = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        setObj({ ...object });
        return;
      }
      if (imageModal.controlKey === 'product_journey_ethicalIcon') {
        object.tier[imageModal.index].ethicalAuditIcon = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        return;
      }
      if (imageModal.controlKey === 'heading') {
        object.iconPath = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        setObj({ ...object });
        return;
      }
      if (imageModal.controlKey === 'company_stamp') {
        object.iconCompanyPath = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        setObj({ ...object });
        return;
      }
      if (imageModal.controlKey === 'url_link') {
        object.metaData.image = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        setObj({ ...object });
        return;
      }
      if (imageModal.controlKey === 'navigation') {
        const parts = imageModal?.name.split('_');
        const index = parts[parts.length - 1];
        object.anchorMenu[index].defaultIcon = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        setObj({ ...object });
        return;
      }
      if (imageModal.controlKey === 'care_user_instruction') {
        object.careLabelDescriptionArr[imageModal.index].image = imageRes;
        setImageModal((prevState) => ({
          ...prevState,
          isOpen: false,
          name: '',
          index: null,
        }));
        setObj({ ...object });
        return;
      }

      const s3Obj = {
        document: imageRes,
      };
      if (obj?.key === 'product_journey') {
        s3Obj.documentName = `${imageModal?.controlKey}_${imageModal?.index}_image`;
      } else if (obj?.key === 'navigation') {
        s3Obj.documentName = `${imageModal?.controlKey}_${imageModal?.name}_image`;
      } else {
        s3Obj.documentName = `${obj?.key}_${dppState?.editPopupItemIndex}_image`;
      }
      await dispatch(dppAction.uploadDPPImage(s3Obj));

      setObj({ ...object });
      setImageModal((prevState) => ({
        ...prevState,
        isOpen: false,
        name: '',
        index: null,
      }));
    } else {
      setImageModal((prevState) => ({
        ...prevState,
        isOpen: false,
        name: '',
        index: null,
      }));
    }
  };

  const handleControlImageUpload = (key, name, index) => {
    setImageModal((prevState) => ({
      ...prevState,
      isOpen: true,
      controlKey: key,
      name,
      index,
    }));
  };

  const updateConfigSetting = (updatedData) => {
    setObj({ ...updatedData });
  };

  const handleChangeByPath = (val, path) => {
    console.log('valvalval', val, path);
    let cloneObj = { ...obj };
    if (path) {
      set(cloneObj, path, val);
    } else {
      cloneObj = val;
    }
    setObj(cloneObj);
  };

  const mainBodyData = () => {
    return (
      <>
        <div>
          {data?.key === 'html' && (
            <HtmlSetting
              obj={obj}
              onChange={onChange}
              handleOtherConfig={handleOtherConfig}
              handleBorderStyle={handleBorderStyle}
              handleFontSize={handleFontSize}
            />
          )}
          {data?.key === 'google' && <GoogleSetting obj={obj} onChange={onChange} updateSetting={updateConfigSetting} />}
          {data?.key === 'product_journey' && (
            <ProductJourneySetting
              handleImageUpload={handleControlImageUpload}
              obj={obj}
              updateSetting={updateConfigSetting}
              onChange={onChange}
              handleOtherConfig={handleOtherConfig}
              fromProduct={false}
              libraryBasicData={libraryBasicData}
            />
          )}
          {data?.key === 'heading' && (
            <HeadingSettingComp obj={obj} onChange={onChange} handleImageUpload={handleControlImageUpload} handleHeadingStyle={handleHeadingStyle} />
          )}
          {data?.key === 'spacer' && <SpacerSetting obj={obj} handleSpacerStyle={handleSpacerStyle} />}
          {data?.key === 'url_link' && (
            <URLLinkSettingComp
              obj={obj}
              handleImageUpload={handleControlImageUpload}
              onChange={onChange}
              updateMetaData={updateMetaData}
              handleURLSwitch={handleURLSwitch}
              handleOtherConfig={handleOtherConfig}
              handleFontSize={handleFontSize}
            />
          )}
          {data?.key === 'digital_asset' && <DAMSettingComp obj={obj} updateSetting={updateConfigSetting} />}
          {data?.key === 'source' && <SourceSettingComp obj={obj} updateSetting={updateConfigSetting} />}
          {data?.key === 'testing_control' && (
            <TestingControlSetting ref={testingRef} obj={obj} updateSetting={updateConfigSetting} handleImageUpload={handleControlImageUpload} />
          )}
          {data?.key === 'product_impact' && <ProductImpactSetting handleChangeByPath={handleChangeByPath} obj={obj} />}
          {data?.key === 'navigation' && (
            <NavigationSetting
              handleChangeByPath={handleChangeByPath}
              obj={obj}
              handleImageUpload={handleControlImageUpload}
              allCustomSection={allCustomSection || []}
              customSectionIndexs={customSectionIndexs}
            />
          )}
          {data?.key === 'custom_section' && <CustomSetting handleChangeByPath={handleChangeByPath} obj={obj} updateSetting={updateConfigSetting} />}
          {data?.key === 'care_user_instruction' && (
            <CareUserInstructionSetting handleChangeByPath={handleChangeByPath} obj={obj} handleImageUpload={handleControlImageUpload} ref={careUserref} />
          )}
          {data?.key === 'company_stamp' && <CompanyStampSetting obj={obj} handleImageUpload={handleControlImageUpload} />}
        </div>

        <div className="d-flex">
          {hasAccessAlignment(data?.key) && <AlignmentConfigComponent obj={obj} handleAlignment={handleOtherConfig} dataName="alignment" />}
          {hasAccessBackground(data?.key) && <BackgraundColorConfig obj={obj} handleBackground={handleOtherConfig} />}
          {hasAccessColor(data?.key) && <ColorConfig obj={obj} handleColor={handleOtherConfig} dataName="color" />}
          {hasAccessBold(data?.key) && <BoldConfig obj={obj} handleBold={handleOtherConfig} dataName="bold" />}
          {hasAccessUnderlineColor(data?.key) && <UnderlineColorConfig obj={obj} handleUnderline={handleOtherConfig} />}
        </div>

        {hasAccessBorder(data?.key) && (
          <>
            <BorderConfig obj={obj} handleBorder={handleOtherConfig} />
            <BorderColorConfig obj={obj} handleBorder={handleOtherConfig} />
            <BorderStyleConfig obj={obj} handleBorderStyle={handleBorderStyle} />
          </>
        )}
        {data?.key === 'source' && (
          <>
            <BorderConfig obj={obj} paddingTopZero handleBorder={handleOtherConfig} />
            <div className="d-flex mt-16">
              <div className="w-100px mr-16">
                <p className="f-16 text-bold mb-2">{t('DPP.CONTROL.PRODUCTJOURNEY.BORDER_LINE')}</p>
                <Select
                  options={verticalStyleOptions}
                  className="common-select"
                  menuPosition="fixed"
                  styles={customStylesBorderLine}
                  classNamePrefix="common-select"
                  getOptionLabel={({ label }) => `${label}`}
                  getOptionValue={({ value }) => `${value}`}
                  value={verticalStyleOptions?.find((ele) => ele?.value === obj?.otherConfiguration?.border_style) || null}
                  onChange={(selected) => handleOtherConfig(selected, 'border_style')}
                />
              </div>
              <ColorConfig obj={obj} paddingTopZero handleColor={handleOtherConfig} dataName="border_color" />
              <div className="thickness-container">
                <img src={borderThickSvg} alt="thickness" />
                <div className="ml-16 w-80px">
                  <Select
                    options={borderStyleOptions}
                    className="common-select"
                    menuPosition="fixed"
                    classNamePrefix="common-select"
                    styles={customStylesBorderThickness}
                    getOptionLabel={({ label }) => `${label}`}
                    getOptionValue={({ value }) => `${value}`}
                    value={borderStyleOptions?.find((ele) => ele?.value === obj?.otherConfiguration?.borderThickness) || null}
                    onChange={(selected) => handleOtherConfig(selected, 'borderThickness')}
                  />
                </div>
              </div>
            </div>

            <div className="common-input-control mt-24">
              <p className="field-name">{t('DPP.CONTROL.HEADING.REPLACEMENT_TITLE')}</p>
              <input
                type="text"
                className="form-control"
                value={obj?.otherConfiguration?.sourceMainTitle}
                placeholder="Enter Replacement title"
                onChange={handleOtherConfig}
                name="sourceMainTitle"
              />
            </div>

            <div className="mr-8">
              <div className="d-flex align-items-center pl-0 design-switch">
                <input
                  type="checkbox"
                  className="form-check-input bom-switch-input mt-0 ml-0"
                  checked={obj?.otherConfiguration?.sourceSwitchTitle}
                  name="sourceSwitchTitle"
                  onChange={handleOtherConfig}
                />
                <span className="ml-16 f-16 text-medium">Include Title Name</span>
              </div>
            </div>
          </>
        )}
      </>
    );
  };
  const areAllColumnsEmpty = data?.key === 'Table' || data?.key === 'HTML' ? false : data?.columns?.every((column) => column.length === 0);

  function isValidURL(url) {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  }

  function hasValidKeys(obj, keys) {
    return keys.every((key) => {
      const value = obj?.[key];

      if (typeof value === 'string') {
        return value.trim() !== '';
      }

      if (typeof value === 'object' && value !== null) {
        return Object.keys(value).length > 0;
      }

      return false;
    });
  }

  const isValidData = (objData) => {
    switch (objData?.key) {
      case 'url_link':
        if (isValidURL(objData?.url)) {
          return objData?.url?.trim() !== '';
        }
        setObj({ ...obj, url: '' });
        toasterMsg(t('DPP.CONTROL.URL_LINK.INVALID_URL'), 'danger');
        break;
      case 'heading':
        return objData?.value?.trim() !== '';
      case 'html':
      case 'google':
      case 'testing_control':
      case 'care_user_instruction':
      case 'navigation':
      case 'custom_section':
        return true;
      case 'company_stamp':
        return true;
      case 'digital_asset':
        return hasValidKeys(objData?.relation, ['attribute', 'location']);
      case 'source':
        if (objData?.moduleName === 'productIdentifier') {
          return hasValidKeys(objData?.relation, ['location', 'output', 'subLocation']);
        }
        break;
      case 'product_impact':
        if (objData?.properties?.productImpactType === 'manual') {
          return hasValidKeys(objData?.properties, ['waterUsage', 'globalWarmingPotential']);
        }
        return true;
      case 'spacer':
        return hasValidKeys(objData?.spacerHeight, ['value']);
      case 'product_journey':
        if (objData?.productType?.length > 0 && objData?.bomType?.length > 0) {
          return true;
        }
        return false;
      default:
        break;
    }
  };

  const handleSaveConfig = async () => {
    let testingControlData = null;
    if (obj?.key === 'testing_control') {
      const isTestingValid = await testingRef.current.validateTestingSetting();
      if (!isTestingValid) {
        testingControlData = await testingRef.current.getLocalState();
      } else {
        return;
      }
    }
    if (obj?.key === 'care_user_instruction') {
      const isCareValid = await careUserref.current.validateCareLabel();
      if (isCareValid) {
        return; // Exit if validation fails
      }
      testingControlData = obj; // Proceed if validation passes
    }

    if (obj?.key === 'product_journey' && obj?.bomType?.length > 0) {
      const filteredData = bomOptionsList?.map((bomType) => bomType?._id);
      const allBomsdata = obj?.bomType?.filter((bomType) => filteredData?.includes(bomType.id));
      obj.bomType = allBomsdata;
    }

    if (obj?.key === 'product_journey' && obj?.tier?.length > 0) {
      const tierData = obj?.tier?.map((tier) => ({
        ...tier,
        name: tier.name || tier.label,
      }));
      obj.tier = tierData || obj.tier;
    }

    const isValid = isValidData(obj);
    if (isValid) {
      const results = obj?.options?.filter((eleOption) => eleOption?.name?.trim() === '');
      if (results?.length > 0) {
        toasterMsg(t('DPP.OPTION_REQUIRED'), 'danger');
      } else {
        const cloneObj = testingControlData || obj || data;
        submit(cloneObj, dataIndex, customSectionIndex);
      }
    } else {
      toasterMsg(t('DPP.REQUIRED_VALIDATION'), 'danger');
    }
  };

  const filePreview = (element) => {
    return element ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${element}`) : '';
  };

  const getImageData = () => {
    if (obj?.key === 'heading') {
      return filePreview(obj?.iconPath);
    }
    if (obj?.key === 'company_stamp') {
      return filePreview(obj?.iconCompanyPath);
    }
    if (obj?.key === 'url_link' && obj?.metaData?.image && obj?.metaData?.image.includes('url_link')) {
      return filePreview(obj?.metaData?.image);
    }
    if (obj?.key === 'testing_control') {
      const testImage = obj?.testGroup?.[imageModal?.index]?.testIconImage;
      return filePreview(testImage);
    }
    if (obj?.key === 'product_journey') {
      if (imageModal?.index === null || imageModal?.index === undefined) {
        const testImage = obj?.transportIcon;
        return filePreview(testImage);
      }
      const testImage = obj?.tier?.[imageModal?.index]?.tierIcon;
      return filePreview(testImage);
    }
    if (obj?.key === 'navigation') {
      const parts = imageModal?.name.split('_');
      const index = parts[parts.length - 1];
      const testImage = obj?.anchorMenu?.[index]?.defaultIcon;
      return filePreview(testImage);
    }
    if (obj?.key === 'care_user_instruction') {
      const testImage = obj?.careLabelDescriptionArr?.[imageModal?.index]?.image;
      return filePreview(testImage);
    }
  };

  return (
    <>
      <div className="common-config-container">
        <Card className="common-custom-card">
          <Card.Header className="d-flex">
            <p className="mb-0 f-24 flex-fill text-center">
              {obj?.label} {t('DPP.FIELD_PROPERTIES')}
            </p>
            <span onClick={toggle} className="icon-close cursor-pointer" />
          </Card.Header>
          <Card.Body className="overflow-auto p-24 f-14">{mainBodyData()}</Card.Body>
          <Card.Footer>
            <button disabled={areAllColumnsEmpty} aria-label="button" className="btn d-inline-flex p-0" type="button" onClick={() => handleSaveConfig()}>
              <span className="icon-Tick-1 f-24" />
            </button>
          </Card.Footer>
        </Card>
      </div>
      {imageModal.isOpen && (
        <Modal className="common-custom-modal image-upload" show={imageModal.isOpen} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('DPP.UPLOAD_IMAGE')}</Modal.Title>
            <span
              onClick={() => {
                setImageModal((prev) => ({ ...prev, isOpen: false, controlKey: '', name: '', index: null }));
              }}
              className="icon-close cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <ImgDropzone
              ref={childRef}
              onSubmit={handleImageUpload}
              acceptedFileExtenstion=".jpeg,.png,.jpg"
              title=""
              image={getImageData()}
              isEditMode={false}
              cropSize="FREE"
              fromCustomModule
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default ConfigModal;
